import axios from 'axios';

/**
 * Global axios defaults.
 *
 * `withXSRFToken: true` tells axios to read the XSRF-TOKEN cookie that Laravel
 * sets (and rotates on session regeneration) and forward it as the
 * `X-XSRF-TOKEN` header on every request. This means we never need to manually
 * read `<meta name="csrf-token">`, which goes stale after the first Inertia
 * POST/PUT/DELETE rotates the session.
 *
 * `basePath` is exported (not applied to axios) so the Inertia router patch
 * in app.jsx can prefix URLs. We deliberately do NOT set axios.defaults.baseURL
 * — the router patch already rewrites paths to include the prefix, and a
 * baseURL on top would double it.
 *
 * For direct axios.* calls in components (not via Inertia router), see
 * `apiUrl()` helper in @/lib/url.
 */
const basePathMeta = document.querySelector('meta[name="base-path"]');
const basePath = (basePathMeta?.getAttribute('content') ?? '').replace(/\/$/, '');

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'application/json';

// Interceptor: prefix absolute paths with basePath. Idempotent — skips
// requests that already include the prefix (Inertia router rewrites first).
if (basePath) {
    axios.interceptors.request.use((config) => {
        const url = config.url;
        if (typeof url !== 'string') return config;
        if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//')) return config;
        if (! url.startsWith('/')) return config;
        if (url.startsWith(basePath + '/') || url === basePath) return config;
        config.url = basePath + url;
        return config;
    });
}

window.axios = axios;
window.kodmailBasePath = basePath;

export default axios;
export { basePath };
